import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, flatMap, take } from 'rxjs/operators';
import { AuthenticationService } from '../authentication.service';

/**
 * Intercept all http request made from the ``Communication`` service and set
 * the ``Authorization`` parameter from the header of the request.
 *
 * When the server responds with han unauthorized code ( because the ``refresh
 * token``
 * has expired ) and the ``token`` has not expired yet the service will request
 * for a new ``refresh token``.
 * Other request that has been called during that process will be freezed until
 * a new ``refresh token`` is provided.
 *
 * In case that the ``token`` has expired, it will send to ``Login`` page.
 */
@Injectable({
  providedIn: 'root',
})
export class AuthenticationInterceptorService implements HttpInterceptor {
  constructor(private authService: AuthenticationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.authService.authorizeRequest(request)).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse) {
          // if not authorized
          if (err.status === 401) {
            if (err.error && err.error.data === 'invalid_grant') {
              this.authService.cleanSession();
            } else if (this.authService.isAuth()) {
              if (this.authService.isRefreshingToken()) {
                return this.authService.onTokenRefresh().pipe(
                  take(1),
                  flatMap(() => next.handle(this.authService.authorizeRequest(request))),
                );
              }
              return this.authService.refreshToken().pipe(flatMap(() => next.handle(this.authService.authorizeRequest(request))));
            }
          }
        }
        return throwError(err);
      }),
    );
  }
}
